export default class Header {
    constructor() {
        console.info('Header.constructor()');

        this.initListeners();
    }

    initListeners() {
        $(window).scroll(() => {
            const scroll = $(window).scrollTop();

            if (scroll > 55) {
                $('#header--global').addClass('fixed');
            } else {
                $('#header--global').removeClass('fixed');
            }
        });

        $('.js-search-toggle').on('click', (e) => {
            e.preventDefault();

            $(e.currentTarget).addClass('active');
            $('.js-search-form').fadeIn();
        });

        $(document).mouseup((e) => {
            const container = $('.js-search-form');

            // if the target of the click isn't the container nor a descendant of the container
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                container.fadeOut();
                $('.js-search-toggle').removeClass('active');
            }
        });

        $('.js-submenu-toggle').on('click', (e) => {
            e.preventDefault();

            $(e.currentTarget).closest('.menu-item').toggleClass('active');
        });
    }
}
